<template>
  <quiz-layout>
    <template #sidebar>
      <div class="sidebar__menu">
        <router-link class="menu__item" :to="`/admin`">
          <div class="item__title">Lessons</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/users`">
          <div class="item__title">Users</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards`">
          <div class="item__title">Rewards</div>
        </router-link>
        <router-link class="menu__item" :to="`/admin/rewards/claims`">
          <div class="item__title">Claims</div>
        </router-link>
      </div>
    </template>
    <template>
      <div class="content__title__wrapper">
        <div class="content__title">Quiz Detail</div>
        <!-- todo add/edit quiz -->
        <div class="content__title__action" v-if="questionExists !== null">
          <button v-b-modal="'addQuestion'">
            {{ questionExists ? "Add Question" : "Add Quiz" }}
          </button>
          <template v-if="questionExists">
            <button v-b-modal="'editQuiz'">Edit Quiz</button>
          </template>
        </div>
      </div>
      <div class="content__group">
        <div
          class="question-card"
          :key="`questionKey${index}`"
          v-for="(question, index) in questions"
        >
          <div class="question">
            {{ index + 1 }}. {{ question.questionText }}
          </div>
          <div class="answer-options">
            <div
              class="option-wrapper"
              :key="`option${index}${optionIndex}`"
              v-for="(option, optionIndex) in question.options.filter(
                (option) => option.value !== ''
              )"
            >
              <div>
                <label :for="`option${index}${optionIndex}`">{{
                  option.value
                }}</label>
              </div>
            </div>
            <div class="answer-action-wrapper">
              <div class="answer-content">
                <div>
                  <b>Answers:</b>
                </div>
                <div
                  v-for="(answer, answerIndex) in question.solution"
                  :key="'solution' + answerIndex"
                >
                  <span>{{ answer }}</span>
                </div>
              </div>
              <div class="action-btn">
                <span class="mr-4">
                  <svg
                    width="20"
                    height="20"
                    @click="
                      setSelectedQuestionModal(question, 'updateQuestionModal')
                    "
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.2414 8.8117V17.3939C17.2409 18.0222 16.9909 18.6245 16.5468 19.0687C16.1025 19.5128 15.5001 19.7624 14.872 19.7629H2.61896C1.99098 19.7623 1.38866 19.5125 0.944653 19.0684C0.500508 18.6242 0.250719 18.022 0.25 17.3939V5.13941C0.250561 4.51129 0.500357 3.90911 0.94451 3.46497C1.38866 3.02082 1.99084 2.77103 2.61896 2.77046H11.5245C11.7391 2.77453 11.9358 2.89142 12.0419 3.07793C12.1481 3.26457 12.1481 3.4933 12.0419 3.67982C11.9358 3.86646 11.7391 3.98322 11.5245 3.98729H2.61896C2.31331 3.98729 2.02015 4.10868 1.80388 4.32465C1.58749 4.54077 1.46582 4.83379 1.46554 5.13944V17.3939C1.46624 17.6995 1.58805 17.9922 1.8043 18.208C2.02055 18.4239 2.31344 18.545 2.61895 18.5451H14.872C15.1775 18.545 15.4707 18.4237 15.6869 18.2077C15.9032 17.9918 16.0249 17.6987 16.0252 17.3931V8.8116C16.0252 8.59436 16.1411 8.39353 16.3293 8.28493C16.5174 8.17631 16.7493 8.17631 16.9373 8.28493C17.1255 8.39355 17.2414 8.59437 17.2414 8.8116L17.2414 8.8117ZM7.87279 14.1236L16.4036 5.59315L14.5812 3.77022L6.04322 12.309L5.35094 14.7518L7.87286 14.1245L7.87279 14.1236ZM17.263 4.73238L17.6165 4.38014L15.794 2.55847L15.4424 2.91071L17.263 4.7331L17.263 4.73238ZM18.1283 2.04695C17.9478 1.86719 17.7182 1.74467 17.4683 1.695C17.2185 1.64518 16.9594 1.67044 16.7239 1.76741L18.4065 3.45001H18.4064C18.5037 3.21481 18.5291 2.95604 18.4795 2.70639C18.43 2.45674 18.3078 2.22729 18.1283 2.04698L18.1283 2.04695ZM18.9875 1.18643C18.5174 0.717176 17.8805 0.453735 17.2162 0.453735C16.552 0.453735 15.915 0.71714 15.4449 1.18643L5.07111 11.5602C4.99758 11.6336 4.94383 11.7246 4.91492 11.8245L3.89428 15.43C3.83506 15.6388 3.89147 15.8632 4.04219 16.0192C4.19305 16.1753 4.41549 16.2393 4.62612 16.1871L8.33039 15.2643L8.33053 15.2645C8.43761 15.2375 8.53556 15.1821 8.61386 15.1042L18.987 4.73006C19.4564 4.25994 19.7201 3.62269 19.7201 2.95836C19.7201 2.29388 19.4564 1.65678 18.987 1.18666L18.9875 1.18643Z"
                      fill="black"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    width="17"
                    height="21"
                    @click="
                      setSelectedQuestionModal(question, 'deleteQuestionModal')
                    "
                    viewBox="0 0 17 21"
                  >
                    <path
                      d="M16.2 5.29591C16.2 4.80521 16.0051 4.33465 15.6581 3.98769C15.3112 3.64074 14.8406 3.44576 14.3499 3.44576H11.2662C11.2662 2.34408 10.6785 1.32609 9.72438 0.775252C8.77031 0.224412 7.5949 0.224412 6.64079 0.775252C5.68671 1.32609 5.09899 2.34408 5.09899 3.44576H2.01528C1.42936 3.44459 0.877618 3.72177 0.528789 4.19259C0.17996 4.6634 0.0753787 5.27187 0.246936 5.83208C0.418505 6.39243 0.845892 6.83794 1.39864 7.03261V17.1766C1.39937 17.9509 1.70741 18.6932 2.25473 19.2408C2.8022 19.7885 3.54449 20.0965 4.31883 20.0975H12.0465C12.8209 20.0965 13.5632 19.7885 14.1106 19.2408C14.658 18.6932 14.966 17.9509 14.9667 17.1766V7.03261C15.3263 6.9055 15.6377 6.67045 15.8585 6.35948C16.0792 6.04866 16.1986 5.67713 16.2002 5.29584L16.2 5.29591ZM8.18251 1.59554C8.67322 1.59554 9.14377 1.79051 9.49073 2.13747C9.83782 2.48456 10.0327 2.9551 10.0327 3.4458H6.33244C6.33244 2.9551 6.52726 2.48454 6.87436 2.13747C7.22131 1.79053 7.69184 1.59554 8.18259 1.59554H8.18251ZM13.7328 17.1764C13.7324 17.6237 13.5546 18.0525 13.2383 18.3689C12.9221 18.6851 12.4934 18.8631 12.0461 18.8639H4.31839C3.87112 18.8632 3.44239 18.6852 3.12617 18.3689C2.80995 18.0525 2.6321 17.6237 2.63165 17.1764V7.14588H13.7327L13.7328 17.1764ZM14.3497 5.91247H2.01521C1.79493 5.91247 1.59134 5.79487 1.48118 5.60399C1.37104 5.41326 1.37104 5.17822 1.48118 4.98733C1.59132 4.79644 1.79492 4.679 2.01521 4.679H14.3497C14.5699 4.679 14.7735 4.79645 14.8837 4.98733C14.9939 5.1782 14.9938 5.41325 14.8837 5.60399C14.7736 5.79487 14.57 5.91247 14.3497 5.91247Z"
                      fill="black"
                    />
                    <path
                      d="M8.18306 17.014C8.34658 17.014 8.50353 16.9491 8.61909 16.8334C8.73479 16.7177 8.79973 16.5609 8.79973 16.3974V9.61324C8.79973 9.39282 8.68228 9.18922 8.4914 9.07906C8.30067 8.96893 8.06548 8.96893 7.87474 9.07906C7.68386 9.1892 7.56641 9.3928 7.56641 9.61324V16.3974C7.56641 16.5609 7.63135 16.7177 7.74704 16.8334C7.86259 16.9491 8.01954 17.014 8.18308 17.014H8.18306Z"
                      fill="black"
                    />
                    <path
                      d="M10.65 16.3973C10.8135 16.3973 10.9705 16.3322 11.086 16.2167C11.2017 16.101 11.2667 15.9442 11.2667 15.7805V10.2302C11.2667 10.0099 11.1492 9.80632 10.9583 9.69601C10.7676 9.58587 10.5324 9.58587 10.3417 9.69601C10.1508 9.80629 10.0332 10.0099 10.0332 10.2302V15.7805C10.0332 15.9442 10.0983 16.101 10.2138 16.2167C10.3295 16.3322 10.4865 16.3973 10.65 16.3973H10.65Z"
                      fill="black"
                    />
                    <path
                      d="M5.71434 16.3973C5.87787 16.3973 6.03481 16.3322 6.15049 16.2167C6.26604 16.101 6.33113 15.9442 6.33113 15.7805V10.2302C6.33113 10.0099 6.21353 9.80632 6.02265 9.69601C5.83192 9.58587 5.59673 9.58587 5.40598 9.69601C5.21511 9.80629 5.09766 10.0099 5.09766 10.2302V15.7805C5.09766 15.9442 5.1626 16.101 5.27829 16.2167C5.39384 16.3322 5.55078 16.3973 5.71433 16.3973H5.71434Z"
                      fill="black"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal id="editQuiz" centered hide-header hide-footer>
      <h2 class="text-center mt-3 mb-3">Edit Quiz</h2>
      <template v-if="quizDetails !== null">
        <div class="input-wrapper form-group">
          <label for="quizName">Lesson</label>
          <b-form-input
            id="quizName"
            v-model="quizDetails.lessonDetail.lessonName"
            readonly
          />
        </div>

        <div class="input-wrapper form-group">
          <label for="quizName">Quiz Name</label>
          <b-form-input id="quizName" v-model="quizDetails.quiz.name" />
        </div>

        <div class="input-wrapper form-group">
          <label for="quizName">Rewards</label>
          <b-form-input
            id="quizName"
            v-model="quizDetails.quiz.reward"
            type="number"
            min="1"
          />
        </div>

        <div>
          <b-btn
            variant="primary mr-3"
            @click="editQuestion()"
            :disabled="!!quizLoading"
          >
            Update
          </b-btn>
          <b-btn variant="secondary" @click="$bvModal.hide('editQuiz')">
            Cancel
          </b-btn>
        </div>
      </template>
    </b-modal>
    <b-modal id="updateQuestionModal" centered hide-header hide-footer>
      <h2 class="text-center mt-3 mb-3">Update Question</h2>
      <div class="update-question-modal-wrapper" v-if="selectedQuestion">
        <div class="input-wrapper">
          <label for="questionType">Question Type</label>
          <div>
            <b-form-select
              name="questionType"
              v-model="selectedQuestion.type"
              id="questionType"
            >
              <b-select-option
                :value="type"
                :key="'key' + index"
                v-for="(type, index) in types"
              >
                {{ type }}
              </b-select-option>
            </b-form-select>
          </div>
        </div>
        <div class="input-wrapper">
          <label for="question">Question</label>
          <div>
            <b-form-input
              id="question"
              v-model="selectedQuestion.questionText"
            />
          </div>
        </div>
        <div class="input-wrapper">
          <label for="answerOption">
            Options
            <span
              @click="addOption(selectedQuestion.options)"
              class="cursor-pointer"
            >
              <svg width="14" height="14" viewBox="0 0 37 37" fill="none">
                <path
                  d="M18.3485 0.4375C13.5765 0.442851 9.00162 2.34604 5.62696 5.72927C2.25253 9.11249 0.354375 13.6992 0.348633 18.484C1.33766 42.4253 35.3625 42.4188 36.3483 18.4836H36.3486C36.343 13.6993 34.4447 9.11241 31.0703 5.72894C27.6959 2.34604 23.1208 0.442932 18.3488 0.4375H18.3485ZM25.7638 19.4297H19.2921V25.9192V25.9189C19.2921 26.4415 18.8697 26.865 18.3485 26.865C17.8276 26.865 17.4052 26.4415 17.4052 25.9189V19.4297H10.9325C10.4117 19.4297 9.98895 19.0059 9.98895 18.4836C9.98895 17.9614 10.4117 17.5376 10.9325 17.5376H17.4052V11.0487C17.4052 10.5264 17.8276 10.103 18.3485 10.103C18.8697 10.103 19.2921 10.5264 19.2921 11.0487V17.5376H25.7638C26.2774 17.5477 26.689 17.9684 26.689 18.4836C26.689 18.9989 26.2774 19.4195 25.7638 19.4297Z"
                  fill="#024089"
                />
              </svg>
            </span>
          </label>
          <div
            :key="'option' + index"
            v-for="(option, index) in selectedQuestion.options"
          >
            <b-form-input
              v-model="option.value"
              @input="option.text = option.value"
              type="text"
            ></b-form-input>
            <span
              class="ml-2"
              @click="removeOption(selectedQuestion.options, index)"
            >
              <svg
                width="14"
                height="18"
                class="cursor-pointer"
                viewBox="0 0 17 21"
                fill="none"
              >
                <path
                  d="M16.2 5.29591C16.2 4.80521 16.0051 4.33465 15.6581 3.98769C15.3112 3.64074 14.8406 3.44576 14.3499 3.44576H11.2662C11.2662 2.34408 10.6785 1.32609 9.72438 0.775252C8.77031 0.224412 7.5949 0.224412 6.64079 0.775252C5.68671 1.32609 5.09899 2.34408 5.09899 3.44576H2.01528C1.42936 3.44459 0.877618 3.72177 0.528789 4.19259C0.17996 4.6634 0.0753787 5.27187 0.246936 5.83208C0.418505 6.39243 0.845892 6.83794 1.39864 7.03261V17.1766C1.39937 17.9509 1.70741 18.6932 2.25473 19.2408C2.8022 19.7885 3.54449 20.0965 4.31883 20.0975H12.0465C12.8209 20.0965 13.5632 19.7885 14.1106 19.2408C14.658 18.6932 14.966 17.9509 14.9667 17.1766V7.03261C15.3263 6.9055 15.6377 6.67045 15.8585 6.35948C16.0792 6.04866 16.1986 5.67713 16.2002 5.29584L16.2 5.29591ZM8.18251 1.59554C8.67322 1.59554 9.14377 1.79051 9.49073 2.13747C9.83782 2.48456 10.0327 2.9551 10.0327 3.4458H6.33244C6.33244 2.9551 6.52726 2.48454 6.87436 2.13747C7.22131 1.79053 7.69184 1.59554 8.18259 1.59554H8.18251ZM13.7328 17.1764C13.7324 17.6237 13.5546 18.0525 13.2383 18.3689C12.9221 18.6851 12.4934 18.8631 12.0461 18.8639H4.31839C3.87112 18.8632 3.44239 18.6852 3.12617 18.3689C2.80995 18.0525 2.6321 17.6237 2.63165 17.1764V7.14588H13.7327L13.7328 17.1764ZM14.3497 5.91247H2.01521C1.79493 5.91247 1.59134 5.79487 1.48118 5.60399C1.37104 5.41326 1.37104 5.17822 1.48118 4.98733C1.59132 4.79644 1.79492 4.679 2.01521 4.679H14.3497C14.5699 4.679 14.7735 4.79645 14.8837 4.98733C14.9939 5.1782 14.9938 5.41325 14.8837 5.60399C14.7736 5.79487 14.57 5.91247 14.3497 5.91247Z"
                  fill="black"
                />
                <path
                  d="M8.18306 17.014C8.34658 17.014 8.50353 16.9491 8.61909 16.8334C8.73479 16.7177 8.79973 16.5609 8.79973 16.3974V9.61324C8.79973 9.39282 8.68228 9.18922 8.4914 9.07906C8.30067 8.96893 8.06548 8.96893 7.87474 9.07906C7.68386 9.1892 7.56641 9.3928 7.56641 9.61324V16.3974C7.56641 16.5609 7.63135 16.7177 7.74704 16.8334C7.86259 16.9491 8.01954 17.014 8.18308 17.014H8.18306Z"
                  fill="black"
                />
                <path
                  d="M10.65 16.3973C10.8135 16.3973 10.9705 16.3322 11.086 16.2167C11.2017 16.101 11.2667 15.9442 11.2667 15.7805V10.2302C11.2667 10.0099 11.1492 9.80632 10.9583 9.69601C10.7676 9.58587 10.5324 9.58587 10.3417 9.69601C10.1508 9.80629 10.0332 10.0099 10.0332 10.2302V15.7805C10.0332 15.9442 10.0983 16.101 10.2138 16.2167C10.3295 16.3322 10.4865 16.3973 10.65 16.3973H10.65Z"
                  fill="black"
                />
                <path
                  d="M5.71434 16.3973C5.87787 16.3973 6.03481 16.3322 6.15049 16.2167C6.26604 16.101 6.33113 15.9442 6.33113 15.7805V10.2302C6.33113 10.0099 6.21353 9.80632 6.02265 9.69601C5.83192 9.58587 5.59673 9.58587 5.40598 9.69601C5.21511 9.80629 5.09766 10.0099 5.09766 10.2302V15.7805C5.09766 15.9442 5.1626 16.101 5.27829 16.2167C5.39384 16.3322 5.55078 16.3973 5.71433 16.3973H5.71434Z"
                  fill="black"
                />
              </svg>
            </span>
          </div>
        </div>
        <div class="input-wrapper">
          <label for="solution">Solution</label>
          <div>
            <v-select
              :options="selectedQuestion.options"
              :multiple="selectedQuestion.type === 'multiple' ? true : false"
              v-model="selectedQuestion.solution"
              :reduce="(data) => data.value"
              label="text"
            />
          </div>
        </div>
        <div>
          <b-btn variant="primary mr-3" @click="updateQuestion()">Update</b-btn>
          <b-btn
            variant="secondary"
            @click="$bvModal.hide('updateQuestionModal')"
            >Cancel</b-btn
          >
        </div>
      </div>
    </b-modal>
    <b-modal id="addQuestion" centered hide-header hide-footer @hidden="close">
      <h2 class="text-center mt-3 mb-3">
        {{ questionExists === false ? "Add Quiz" : "Add Question" }}
      </h2>
      <div class="update-question-modal-wrapper" v-if="quizPlaceHolder">
        <div class="input-wrapper" v-if="questionExists === false">
          <label for="quizName">Quiz Name</label>
          <b-form-input id="quizName" v-model="quizPlaceHolder.name" />
        </div>
        <div class="input-wrapper">
          <label for="questionType">Question Type</label>
          <div>
            <b-form-select
              name="questionType"
              v-model="quizPlaceHolder.type"
              id="questionType"
            >
              <b-select-option
                :value="type"
                :key="'key' + index"
                v-for="(type, index) in types"
              >
                {{ type }}
              </b-select-option>
            </b-form-select>
          </div>
        </div>
        <div class="input-wrapper">
          <label for="question">Question</label>
          <div>
            <b-form-input
              id="question"
              v-model="quizPlaceHolder.questionText"
            />
          </div>
        </div>
        <div class="input-wrapper">
          <label for="answerOption">
            Options
            <span
              @click="addOption(quizPlaceHolder.options)"
              class="cursor-pointer"
            >
              <svg width="14" height="14" viewBox="0 0 37 37" fill="none">
                <path
                  d="M18.3485 0.4375C13.5765 0.442851 9.00162 2.34604 5.62696 5.72927C2.25253 9.11249 0.354375 13.6992 0.348633 18.484C1.33766 42.4253 35.3625 42.4188 36.3483 18.4836H36.3486C36.343 13.6993 34.4447 9.11241 31.0703 5.72894C27.6959 2.34604 23.1208 0.442932 18.3488 0.4375H18.3485ZM25.7638 19.4297H19.2921V25.9192V25.9189C19.2921 26.4415 18.8697 26.865 18.3485 26.865C17.8276 26.865 17.4052 26.4415 17.4052 25.9189V19.4297H10.9325C10.4117 19.4297 9.98895 19.0059 9.98895 18.4836C9.98895 17.9614 10.4117 17.5376 10.9325 17.5376H17.4052V11.0487C17.4052 10.5264 17.8276 10.103 18.3485 10.103C18.8697 10.103 19.2921 10.5264 19.2921 11.0487V17.5376H25.7638C26.2774 17.5477 26.689 17.9684 26.689 18.4836C26.689 18.9989 26.2774 19.4195 25.7638 19.4297Z"
                  fill="#024089"
                />
              </svg>
            </span>
          </label>
          <div
            :key="'option' + index"
            v-for="(option, index) in quizPlaceHolder.options"
          >
            <b-form-input
              v-model="option.value"
              @input="option.text = option.value"
              type="text"
            ></b-form-input>
            <span
              class="ml-2"
              @click="removeOption(quizPlaceHolder.options, index)"
            >
              <svg
                width="14"
                height="18"
                class="cursor-pointer"
                viewBox="0 0 17 21"
                fill="none"
              >
                <path
                  d="M16.2 5.29591C16.2 4.80521 16.0051 4.33465 15.6581 3.98769C15.3112 3.64074 14.8406 3.44576 14.3499 3.44576H11.2662C11.2662 2.34408 10.6785 1.32609 9.72438 0.775252C8.77031 0.224412 7.5949 0.224412 6.64079 0.775252C5.68671 1.32609 5.09899 2.34408 5.09899 3.44576H2.01528C1.42936 3.44459 0.877618 3.72177 0.528789 4.19259C0.17996 4.6634 0.0753787 5.27187 0.246936 5.83208C0.418505 6.39243 0.845892 6.83794 1.39864 7.03261V17.1766C1.39937 17.9509 1.70741 18.6932 2.25473 19.2408C2.8022 19.7885 3.54449 20.0965 4.31883 20.0975H12.0465C12.8209 20.0965 13.5632 19.7885 14.1106 19.2408C14.658 18.6932 14.966 17.9509 14.9667 17.1766V7.03261C15.3263 6.9055 15.6377 6.67045 15.8585 6.35948C16.0792 6.04866 16.1986 5.67713 16.2002 5.29584L16.2 5.29591ZM8.18251 1.59554C8.67322 1.59554 9.14377 1.79051 9.49073 2.13747C9.83782 2.48456 10.0327 2.9551 10.0327 3.4458H6.33244C6.33244 2.9551 6.52726 2.48454 6.87436 2.13747C7.22131 1.79053 7.69184 1.59554 8.18259 1.59554H8.18251ZM13.7328 17.1764C13.7324 17.6237 13.5546 18.0525 13.2383 18.3689C12.9221 18.6851 12.4934 18.8631 12.0461 18.8639H4.31839C3.87112 18.8632 3.44239 18.6852 3.12617 18.3689C2.80995 18.0525 2.6321 17.6237 2.63165 17.1764V7.14588H13.7327L13.7328 17.1764ZM14.3497 5.91247H2.01521C1.79493 5.91247 1.59134 5.79487 1.48118 5.60399C1.37104 5.41326 1.37104 5.17822 1.48118 4.98733C1.59132 4.79644 1.79492 4.679 2.01521 4.679H14.3497C14.5699 4.679 14.7735 4.79645 14.8837 4.98733C14.9939 5.1782 14.9938 5.41325 14.8837 5.60399C14.7736 5.79487 14.57 5.91247 14.3497 5.91247Z"
                  fill="black"
                />
                <path
                  d="M8.18306 17.014C8.34658 17.014 8.50353 16.9491 8.61909 16.8334C8.73479 16.7177 8.79973 16.5609 8.79973 16.3974V9.61324C8.79973 9.39282 8.68228 9.18922 8.4914 9.07906C8.30067 8.96893 8.06548 8.96893 7.87474 9.07906C7.68386 9.1892 7.56641 9.3928 7.56641 9.61324V16.3974C7.56641 16.5609 7.63135 16.7177 7.74704 16.8334C7.86259 16.9491 8.01954 17.014 8.18308 17.014H8.18306Z"
                  fill="black"
                />
                <path
                  d="M10.65 16.3973C10.8135 16.3973 10.9705 16.3322 11.086 16.2167C11.2017 16.101 11.2667 15.9442 11.2667 15.7805V10.2302C11.2667 10.0099 11.1492 9.80632 10.9583 9.69601C10.7676 9.58587 10.5324 9.58587 10.3417 9.69601C10.1508 9.80629 10.0332 10.0099 10.0332 10.2302V15.7805C10.0332 15.9442 10.0983 16.101 10.2138 16.2167C10.3295 16.3322 10.4865 16.3973 10.65 16.3973H10.65Z"
                  fill="black"
                />
                <path
                  d="M5.71434 16.3973C5.87787 16.3973 6.03481 16.3322 6.15049 16.2167C6.26604 16.101 6.33113 15.9442 6.33113 15.7805V10.2302C6.33113 10.0099 6.21353 9.80632 6.02265 9.69601C5.83192 9.58587 5.59673 9.58587 5.40598 9.69601C5.21511 9.80629 5.09766 10.0099 5.09766 10.2302V15.7805C5.09766 15.9442 5.1626 16.101 5.27829 16.2167C5.39384 16.3322 5.55078 16.3973 5.71433 16.3973H5.71434Z"
                  fill="black"
                />
              </svg>
            </span>
          </div>
        </div>
        <div class="input-wrapper">
          <label for="solution">Solution</label>
          <div>
            <v-select
              :options="quizPlaceHolder.options"
              :multiple="quizPlaceHolder.type === 'multiple' ? true : false"
              v-model="quizPlaceHolder.solution"
              :reduce="(data) => data.value"
              label="text"
            />
          </div>
        </div>
        <div>
          <b-btn
            variant="primary mr-3"
            @click="addQuizQuestion()"
            :disabled="!!quizLoading"
          >
            Add
          </b-btn>
          <b-btn variant="secondary" @click="$bvModal.hide('addQuestion')">
            Cancel
          </b-btn>
        </div>
      </div>
    </b-modal>
    <b-modal id="deleteQuestionModal" centered hide-header hide-footer>
      <p class="mb-3 text-center">Do you want to delete question?</p>
      <div class="text-center">
        <b-btn
          variant="primary"
          class="mr-3 pl-3 pr-3"
          @click="deleteQuestion()"
          >Yes</b-btn
        >
        <b-btn
          variant="secondary"
          class="mr-3 pl-3 pr-3"
          @click="$bvModal.hide('deleteQuestionModal')"
          >No</b-btn
        >
      </div>
    </b-modal>
  </quiz-layout>
</template>
<script>
import QuizLayout from "../layout/QuizLayout.vue";
import { QuizService } from "../data/services/quiz.service";
import { AxiosError } from "axios";
export default {
  components: { QuizLayout },
  data() {
    return {
      type: {
        single: "radio",
        multiple: "checkbox",
      },
      types: [
        "single",
        "multiple",
        // 'definition',
      ],
      isLoading: true,
      initQuestions: [],
      questions: [],
      selectedQuestion: null,
      quizPlaceHolder: {
        name: "",
        options: [
          {
            text: "",
            value: "",
          },
        ],
        reward: 1,
        solution: null,
        type: "single",
        questionText: "",
      },
      questionExists: null,
      quizDetails: null,
      quizLoading: false,
    };
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
  },
  mounted() {
    this.getQuiz().then(this.getQuestions);
  },
  methods: {
    async getQuestions() {
      //
      const quizService = new QuizService();
      await quizService.getQuizQuestions(this.slug).then((response) => {
        this.questions = response;
      });
    },
    async getQuiz() {
      const quizService = new QuizService();
      await quizService
        .getQuiz(this.slug)
        .then((response) => {
          this.questionExists = true;
          this.quizDetails = response;
        })
        .catch((error) => {
          if (error instanceof AxiosError) {
            const { data } = error.response;
            if (data.errors.httpCode === 400) {
              this.questionExists = false;
            }
          }
        });
    },

    async addQuizQuestion() {
      let createQuiz = false;
      if (this.questionExists === false) {
        createQuiz = true;
      }
      const lessonSlug = this.slug;
      const payload = this.quizPlaceHolder;
      if (payload.questionText === "") {
        return this.$notify({
          type: "error",
          title: "Validation Error",
          text: "Question cannot be empty.",
        });
      }

      const filteredOptions = payload.options.filter(
        (option) => option.value !== ""
      );
      if (filteredOptions.length < 2) {
        return this.$notify({
          type: "error",
          title: "Validation Error",
          text: "Atleast two options is required.",
        });
      }

      if (payload.type === "single" && payload.solution === null) {
        return this.$notify({
          type: "error",
          title: "Validation Error",
          text: "Solution is required.",
        });
      }

      if (payload.type === "multiple") {
        const filteredSolutions = payload.solution.filter(
          (solution) => solution !== ""
        );
        if (filteredSolutions.length === 0) {
          return this.$notify({
            type: "error",
            title: "Validation Error",
            text: "Solution is required.",
          });
        }
      }

      if (this.quizLoading === true) {
        return;
      }
      this.quizLoading = true;
      payload.lessonSlug = lessonSlug;

      const quizService = new QuizService();
      const question = await quizService.addChoiceQuestion(payload);
      const questionPayload = {
        choiceQuestion: question._id,
        score: 10,
      };
      if (createQuiz) {
        const questionsList = this.questions.map((question) => {
          return {
            choiceQuestion: question.id,
            score: 10,
          };
        });
        const createPayload = {
          lessonSlug,
          name: payload.name,
          reward: payload.reward,
          questions: [questionPayload, ...questionsList],
        };
        await quizService.createQuiz(createPayload);
        this.questionExists = true;
        this.getQuiz();
        this.$notify({
          title: "Success",
          text: "Quiz has been created.",
        });
      } else {
        const id = this.quizDetails.quiz.id;
        await quizService.addQuestionToQuiz(id, questionPayload);
        this.$notify({
          title: "Success",
          text: "Question has been added to the quiz.",
        });
      }
      this.getQuestions();
      this.$bvModal.hide("addQuestion");
      this.quizLoading = false;
    },
    async editQuestion() {
      const payload = {
        lessonSlug: this.quizDetails.quiz.lessonSlug,
        name: this.quizDetails.quiz.name,
        reward: this.quizDetails.quiz.reward,
      };

      const { name, reward } = payload;

      if (name === undefined || name === "") {
        return this.$notify({
          type: "error",
          title: "Validation Error",
          text: "Quiz name cannot be empty.",
        });
      }

      if (reward <= 0 || reward === undefined || reward === "") {
        return this.$notify({
          type: "error",
          title: "Validation Error",
          text: "Rewards cannot be less than 1.",
        });
      }
      if (this.quizLoading === true) {
        return;
      }
      this.quizLoading = true;

      const quizService = new QuizService();
      await quizService.updateQuiz(this.quizDetails.quiz.id, payload);
      this.$notify({
        title: "Success",
        text: "Quiz has been updated.",
      });
      this.$bvModal.hide("editQuiz");
      this.quizLoading = false;
      this.getQuiz();
      this.getQuestions();
    },
    close() {
      this.quizPlaceHolder.name = "";
      this.quizPlaceHolder.options = [
        {
          text: "",
          value: "",
        },
      ];
      this.quizPlaceHolder.solution = null;
      this.quizPlaceHolder.questionText = "";
    },
    setSelectedQuestionModal(question, modal) {
      console.log("question => ", question);
      this.selectedQuestion = { ...question };
      this.openQuestionModal(modal);
    },
    openQuestionModal(modal) {
      this.$bvModal.show(modal);
    },
    addOption(options) {
      options.push({
        text: "",
        value: "",
      });
    },
    removeOption(options, index) {
      options.splice(index, 1);
    },
    async updateQuestion() {
      const quizService = new QuizService();
      await quizService
        .updateChoiceQuestion(this.selectedQuestion.id, this.selectedQuestion)
        .then((response) => {
          console.log("response ", response);
          this.$bvModal.hide("updateQuestionModal");
          this.getQuestions();
        });
    },
    async deleteQuestion() {
      const quizService = new QuizService();
      await quizService
        .deleteChoiceQuestion(this.selectedQuestion.id)
        .then((response) => {
          console.log("response ", response);
          this.$bvModal.hide("deleteQuestionModal");
          this.$notify({
            group: "foo",
            type: "success",
            title: "Success",
            text: "Question removed successfully!",
          });
          this.getQuestions();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  &__title__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__title__action {
    button {
      background: transparent;
      border: none;
      color: #024089;

      &:first-child {
        margin-right: 15px;
      }
    }
  }
  &__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 12px;
  }
  &__group {
    padding: 20px;
    width: 100%;
    //background: white;
    display: flex;
    flex-direction: column;
    border-radius: 10px;

    .question-card {
      margin-bottom: 26px;
      padding: 20px 26px;
      background: #ffffff;
      border-radius: 20px;

      .question {
        margin-bottom: 12px;
      }
      .answer-options {
        padding-left: 18px;

        .option-wrapper {
          margin-bottom: 4px;
          display: flex;
          //gap: 4px;

          input {
            margin: 0;
          }
          label {
            margin: 0;
            margin-left: 12px;
          }
        }

        .answer-action-wrapper {
          display: flex;
          justify-content: space-between;
          padding-left: 12px;

          .answer-content {
            color: #024089;
          }

          .action-btn {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.group {
  &__item {
    display: flex;
    align-content: center;
    justify-content: space-between;
    + .group__item {
      margin-top: 10px;
    }
  }
  &__title {
    font-size: 16px;
    align-self: center;
  }
  &__action {
    cursor: pointer;
    font-size: 14px;
    padding: 4px 15px;
    background: #f1bc04;
    color: #ffffff;
    border-radius: 20px;
  }
}

.sidebar {
  &__menu {
    display: flex;
    flex-direction: column;
  }
}

.menu {
  &__item {
    display: flex;
    cursor: pointer;
    align-items: center;
    + .menu__item {
      margin-top: 10px;
    }
  }
}

.item {
  &__icon {
    width: 26px;
    margin-right: 15px;
    svg {
      width: 100%;
    }
  }
  &__title {
    color: #ffffff;
    font-size: 20px;
    line-height: 24px;
    &:hover {
      color: #f1bc04;
    }
  }
}

.update-question-modal-wrapper {
  padding: 10px 16px;

  .input-wrapper {
    width: 100%;
    margin-bottom: 16px;

    div {
      display: flex;
      gap: 15px;
      width: 100%;
      margin-bottom: 12px;
    }
  }

  .btn-primary {
    background-color: #024089;
  }
}
</style>
